import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer
            className="relative text-white pt-20 pb-10 bg-cover bg-center bg-no-repeat"
            style={{
                backgroundImage: "url('/footer-cars-bg.jpg')", // Yahan apni cars wali image ka naam rakhein
            }}
        >
            {/* Dark Overlay - Text dikhane ke liye */}
            <div className="absolute inset-0 bg-black/70"></div>

            <div className="relative max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12 z-10">

                {/* Column 1: Logo & About */}
                <div>
                    <img src="/logo.png" alt="Raj Kuruma Logo" className="h-24 mb-6 object-contain bg-white/10 p-2 rounded" />
                    <p className="text-gray-200 text-sm leading-relaxed mb-6">
                        Reliable solutions for Car Rental, Property Leasing, and Business Setup in India.
                        With years of experience, we provide professional and transparent services
                        to support businesses and individuals across India.
                    </p>
                    <div className="flex gap-4">
                        <a
                            href="https://www.facebook.com/share/1Dvt3ZrzpB/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-white/20 p-3 rounded-full hover:bg-[#f15a24] transition text-white"
                        >
                            <FaFacebookF />
                        </a>
                        <a
                            href="https://www.instagram.com/rajkuruma_enterprises"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-white/20 p-3 rounded-full hover:bg-[#f15a24] transition text-white"
                        >
                            <FaInstagram />
                        </a>

                        {/* LinkedIn */}
                        <a
                            href="https://www.linkedin.com/in/rajendersinghchaahar?utm_source=share_via&utm_content=profile&utm_medium=member_android"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-white/20 p-3 rounded-full hover:bg-[#f15a24] transition text-white"
                        >
                            <FaLinkedinIn />
                        </a>
                    </div>
                </div>

                {/* Column 2: Our Services */}
                <div>
                    <h3 className="text-xl font-bold mb-6 border-b-2 border-[#f15a24] inline-block pb-2">Our Services</h3>
                    <ul className="space-y-4 text-white">
                        {[
                            { name: 'Home', path: '/' },
                            { name: 'About', path: '/about' },
                            { name: 'Services', path: '/services' },
                            { name: 'FAQ Page', path: '/faq' },
                            { name: 'Contact', path: '/contact' }
                        ].map((item) => (
                            <li key={item.name}>
                                <Link
                                    to={item.path}
                                    className="hover:text-[#f15a24] transition flex items-center"
                                >
                                    » {item.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Column 3: Contact Us */}
                <div>
                    <h3 className="text-xl font-bold mb-6 border-b-2 border-[#f15a24] inline-block pb-2">Contact Us</h3>
                    <div className="space-y-6">
                        <div className="flex items-start gap-4">
                            <span className="text-[#f15a24] text-xl">🕒</span>
                            <div>
                                <p className="text-sm text-gray-300">Working Time</p>
                                <p className="font-bold">24Hrs Open</p>
                            </div>
                        </div>
                        <div className="flex items-start gap-4">
                            <span className="text-[#f15a24] text-xl">📞</span>
                            <div>
                                <p className="text-sm text-gray-300">Phone</p>
                                <p className="font-bold">+91 9999320112</p>
                            </div>
                        </div>
                        <div className="flex items-start gap-4">
                            <span className="text-[#f15a24] text-xl">✉️</span>
                            <div>
                                <p className="text-sm text-gray-300">Email</p>
                                <p className="font-bold">rajkurumaenterprises@gmail.com</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Copyright */}
            <div className="relative z-10 text-center text-gray-300 text-xs mt-16 border-t border-white/20 pt-6">
                © 2026 Rajkuruma Enterprises Pvt Ltd. All Rights Reserved. design & devlopment live india tech
            </div>

            {/* Scroll to Top */}
            <button
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="relative z-10 block mx-auto mt-8 bg-[#f15a24] p-4 rounded-full text-white shadow-lg hover:bg-black transition"
            >
                ↑
            </button>
        </footer>
    );
};

export default Footer;